import { useNavigate } from "react-router-dom";

import { useFixedLayout } from "../../../hooks/useFixedLayout";
import { SplitRowHalf } from "../../../assets/components/ButtonGroup";
import finish from "../../../assets/image/login/finish.png";
import ListCard from "../../../assets/components/ListCard";

const formatBizNumber = (value) => {
  const digits = value.replace(/\D/g, "").slice(0, 10);
  const len = digits.length;

  if (len < 4) return digits;
  if (len < 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 5)}-${digits.slice(5)}`;
};

const AdsRegistStep9 = ({ goToMain, shop, storeBusinessNumber }) => {
  const navigate = useNavigate();
  const { footerRef, bottomSpace } = useFixedLayout();

  const infoRows = [
    { label: "대표자 이름", value: shop?.businessName || "" },
    {
      label: "사업자등록번호",
      value: shop?.businessNumber ? formatBizNumber(shop.businessNumber) : "",
    },
    { label: "업종", value: shop?.category || "" },
  ];

  return (
    <div className="flex flex-col h-full">
      <div
        className="flex-1 px-[6px] pt-[20px] flex flex-col min-h-0 overflow-y-auto"
        style={{ paddingBottom: bottomSpace }}
      >
        <img src={finish} alt="가입 완료" />
        <h2 className="text-t2 text-text-default text-center pt-[24px]">
          환영합니다. 매장 정보가 등록되었어요.
        </h2>
        <p className="text-b1 text-text-subtler text-center pt-[8px] pb-[48px]">
          토큰 구매 후 다양한 마케팅을 시작해 보세요.
        </p>

        <div className="px-[10px]">
          <div className="pb-[12px]">
            <ListCard mode="disabled" title={shop.storeName} subtitle={shop.address} />
          </div>
          <div className="w-full rounded-[16px] px-[12px] bg-surface-light-subtle border border-border-subtle">
            {infoRows.map((item, idx) => (
              <div
                key={item.label}
                className={`flex items-center py-[12px] ${idx !== infoRows.length - 1 ? "border-b border-border-subtle" : ""}`}
              >
                <div className="w-28 text-c2 text-text-subtler">{item.label}</div>
                <div className="flex-1 leading-relaxed text-c1 text-text-subtle text-right">
                  {item.value}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div ref={footerRef} className="fixed bottom-0 left-0 right-0 bg-surface-default">
        <SplitRowHalf
          leftText="메인 화면으로"
          leftType="border"
          rightText="토큰 구매하기"
          onLeft={goToMain}
          onRight={() => navigate("/myticket/non/tab", { state: { storeBusinessNumber } })}
        />
      </div>
    </div>
  );
};

export default AdsRegistStep9;
